import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import {
  getFormattedDay,
  getFormattedMonth,
  getFormattedYear,
  translate,
} from "../../utils/utils";
import GlobalInformationCard from "../../components/useCase/GlobalInformationsCard";
import QuestionChoisesCard from "./QuestionChoisesCard";
import { useMediaQuery } from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function UseCaseDetails({
  open,
  handleClose,
  rowDetails,
  id_owner,
  company,
}) {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width:1400px)");
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      fullWidth
      onClose={handleClose}
      maxWidth="md"
      aria-describedby="alert-dialog-slide-description"
      PaperProps={{
        sx: !isMobile
          ? { width: "35%", padding: "20px " }
          : {
              width: "90%",
              height: "100%",
              margin: "5px 0",
              padding: "5px ",
              backgroundColor: "#F3F9F8",
            },
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "start",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="subtitle3"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <IconButton onClick={handleClose}>
            <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
          </IconButton>
          {t("back")}
        </Typography>

        <div
          style={{
            display: "flex",
            height: isMobile ? "100%" : {},
            flexWrap: isMobile ? "Wrap" : {},
            justifyContent: "center",
            flexDirection: isMobile ? "row" : {},
            width: "100%",
          }}
        >
          <GlobalInformationCard
            label="Source"
            value={rowDetails.source === id_owner ? company : rowDetails.source}
          />

          {console.log("thedateee", rowDetails?.last_update, rowDetails)}
          <GlobalInformationCard
            label="Date"
            value={
              rowDetails?.last_update
                ? `${getFormattedDay(
                    rowDetails?.last_update
                  )} ${getFormattedMonth(
                    rowDetails?.last_update
                  )} ${getFormattedYear(rowDetails?.last_update)}`
                : `${getFormattedDay(
                    rowDetails?.creation_date
                  )} ${getFormattedMonth(
                    rowDetails?.creation_date
                  )} ${getFormattedYear(rowDetails?.creation_date)}`
            }
          />
          <GlobalInformationCard
            label={t("threshold")}
            value={`${rowDetails.threshold}`}
          />

          <GlobalInformationCard
            label="Coefficient"
            value={`${rowDetails.coefficient}`}
          />
          <GlobalInformationCard
            label={t("difficulty")}
            value={t(rowDetails.difficulty_level)}
          />
        </div>
      </div>
      <DialogTitle></DialogTitle>
      <DialogContent sx={{ width: "85%" }}>
        <Grid container alignItems="center">
          <Grid item xs={12}>
            <Typography
              variant="accordion1"
              sx={{
                fontSize: !isMobile ? "30px" : "22px",
                lineHeight: !isMobile ? "30px" : "15px",
              }}
            >
              {rowDetails?.[translate("title")] || t("not_specified")}
            </Typography>
          </Grid>

          <Grid item xs={15} sx={{ marginBottom: "10px", width: "100%" }}>
            <div
              style={{
                color: "rgba(0, 0, 0, 0.5)",
                fontSize: "12px",
                fontWeight: 800,
              }}
            >
              {rowDetails?.[translate("description")] || t("not_specified")}
            </div>
          </Grid>
        </Grid>
        {rowDetails.questions?.map((ques, i) => (
          <Grid item xs={12} key={i}>
            <QuestionChoisesCard questionData={ques} index={i} isDisplayMode />
            <br />
          </Grid>
        ))}
      </DialogContent>
    </Dialog>
  );
}
